<template>
   <div :class="col || 'd-inline-block'">
      <!-- Label above the switches, e.g. "Fancy Checkboxes" -->
      <label v-if="label" class="form-label d-block">{{ label }}</label>

      <!-- horizontal: side by side, never wrapping. vertical: one under the other -->
      <div class="d-flex" :class="layout === 'vertical' ? 'flex-column align-items-start gap-2' : 'flex-nowrap align-items-center gap-4'">
         <div class="sa-field position-relative d-inline-block">
            <!-- custom-tooltip-input: the tooltip script shows the tooltip for this switch -->
            <div class="form-check mb-0 custom-tooltip-input" :class="{ 'form-switch': switchStyle }">
               <input
                  v-bind="$attrs"
                  :id="inputId"
                  class="form-check-input"
                  type="checkbox"
                  :checked="isChecked"
                  @change="$emit('update:modelValue', $event.target.checked)"
               />
               <label class="form-check-label text-nowrap" :for="inputId">{{ text }}</label>
            </div>

            <!-- Above the switch: on focus, and in red while it is invalid (required and not ticked) -->
            <div v-if="tooltip" class="custom-tooltip">{{ tooltip }}<span class="tooltip-arrow"></span></div>
         </div>

         <!-- More switches next to this one, each with its own v-model -->
         <slot />
      </div>
   </div>
</template>

<script>
// A checkbox or switch. Same use as RadioField:
//   <CheckField v-model="formInputs.checkbox1" col="col-md-6" label="Fancy Checkboxes"
//               text="Check me" tooltip="Please tick Check me" required>
//      <CheckField v-model="formInputs.checkbox2" text="Another check" />
//   </CheckField>
// layout="horizontal" (default): the switches side by side. layout="vertical": one under the other.
// Many switches side by side need room: give them a wider column (e.g. col="col-12").
// v-model = true / false. 1, "1" and "true" (from the database) also show as ticked.
// required, @change ... go to the <input>.
let nextId = 0;

export default {
   name: "CheckField",
   inheritAttrs: false,
   props: {
      modelValue: { default: false },
      text: { type: String, default: "" },        // the words next to the box
      label: { type: String, default: "" },       // label above (optional)
      col: { type: String, default: "" },         // e.g. "col-md-6" (empty = sits inline)
      tooltip: { type: String, default: "" },
      id: { type: String, default: "" },
      switchStyle: { type: Boolean, default: true }, // false = a normal square checkbox
      layout: { type: String, default: "horizontal" }, // "horizontal" or "vertical" (the switches inside)
   },
   emits: ["update:modelValue"],
   data() {
      return { autoId: "check-field-" + ++nextId };
   },
   computed: {
      inputId() {
         return this.id || this.autoId;
      },
      isChecked() {
         const v = this.modelValue;
         return v === true || v === 1 || v === "1" || v === "true";
      },
   },
};
</script>